var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.108 18.108C16.7723 19.4436 14.7499 20.2143 12 20.2143C9.25006 20.2143 7.22774 19.4436 5.89206 18.108C4.55637 16.7723 3.78571 14.7499 3.78571 12C3.78571 9.25006 4.55637 7.22774 5.89206 5.89206C7.22774 4.55637 9.25006 3.78571 12 3.78571C12.4931 3.78571 12.8929 3.38597 12.8929 2.89286C12.8929 2.39975 12.4931 2 12 2C8.92137 2 6.39011 2.86863 4.62937 4.62937C2.86863 6.39011 2 8.92137 2 12C2 15.0786 2.86863 17.6099 4.62937 19.3706C6.39011 21.1314 8.92137 22 12 22C15.0786 22 17.6099 21.1314 19.3706 19.3706C21.1314 17.6099 22 15.0786 22 12C22 9.94351 21.6121 8.1317 20.831 6.63127L21.7371 5.72524C21.9559 5.50643 22.0459 5.18993 21.9747 4.88876C21.9036 4.58759 21.6817 4.34471 21.3881 4.24686C20.3439 3.89879 18.9979 3.89879 17.9536 4.24689C17.687 4.33576 17.4779 4.54497 17.3889 4.81159C17.0409 5.85576 17.0409 7.2018 17.389 8.246C17.4869 8.53957 17.7297 8.76153 18.0309 8.83263C18.332 8.90373 18.6486 8.81381 18.8673 8.595L19.4899 7.97241C19.9601 9.0804 20.2143 10.4203 20.2143 12C20.2143 14.7499 19.4436 16.7723 18.108 18.108ZM12 6.53579C11.3096 6.53579 10.75 7.09543 10.75 7.78579V11.3694L8.6553 13.4641C8.16714 13.9522 8.16714 14.7437 8.6553 15.2318C9.14346 15.72 9.93491 15.72 10.4231 15.2318L12.8839 12.771C13.1183 12.5366 13.25 12.2187 13.25 11.8871V7.78579C13.25 7.09543 12.6904 6.53579 12 6.53579Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.f4692196.svg";
export { ForwardRef as ReactComponent };